import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectSections } from '../../../features/sections/sectionSlice';
import { FiX } from 'react-icons/fi';
import { createStudent, updateStudent } from '../../../features/students/studentsAPI'; // Import the API functions

const AddStudent = ({ onClose, groups, studentToUpdate, onStudentUpdate }) => {
  const sections = useSelector(selectSections);

  const initialStudentData = studentToUpdate
    ? { ...studentToUpdate }
    : {
        name: '',
        group: '',
        section_id: '',
        phone_number: '',
        parent_name: '',
        parent_phone_number: ''
      };

  const [studentData, setStudentData] = useState(initialStudentData);

  useEffect(() => {
    // No longer need to filter sections here
  }, [studentData.section_id, sections]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem('token');

      if (studentToUpdate) {
        // If studentToUpdate is provided, update the student
        await updateStudent(token, studentToUpdate.id, studentData);
        console.log('Student updated successfully');
      } else {
        // Otherwise, create a new student
        await createStudent(token, studentData);
        console.log('Student created successfully');
      }

      onClose();
      // Trigger the callback function to notify the parent component of the update
      if (onStudentUpdate) {
        onStudentUpdate();
      }
    } catch (error) {
      console.error('Failed to add/update student:', error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setStudentData({ ...studentData, [name]: value });
  };

  // Function to sort sections by group
  const sortByGroup = (a, b) => {
    if (a.group < b.group) return -1;
    if (a.group > b.group) return 1;
    return 0;
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto p-4 pt-10 lg:pt-16">
      <div className="bg-white rounded-lg shadow-lg p-4 mt-5 w-full max-w-md">
        <div className="flex justify-end mb-4">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 focus:outline-none">
            <FiX className="h-6 w-6" />
          </button>
        </div>
        <h3 className="text-lg font-semibold mb-4">{studentToUpdate ? 'Update Student' : 'Add Student'}</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="mb-2 block">Student Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={studentData.name}
              onChange={handleChange}
              className="border border-gray-300 px-3 py-2 rounded-md w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="section" className="mb-2 block">Section:</label>
            <select
              id="section"
              name="section_id" 
              value={studentData.section_id}
              onChange={handleChange}
              className="border border-gray-300 px-3 py-2 rounded-md w-full"
              required
            >
              <option value="">Select a section</option>
              {[...sections].sort(sortByGroup).map((section, index) => (
                <option key={index} value={section.id}>({section.group}) {section.days} {section.time_period} </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label htmlFor="phone_number" className="mb-2 block">Phone Number:</label>
            <input
              type="text"
              id="phone_number"
              name="phone_number"
              value={studentData.phone_number}
              onChange={handleChange}
              className="border border-gray-300 px-3 py-2 rounded-md w-full"
              required
            />
          </div>
          <div className=" border-t-2 border-t-black-400 mb-4 pt-2">
            <label htmlFor="parent_name" className="mb-2 block">Parent Name:</label>
            <input
              type="text"
              id="parent_name"
              name="parent_name"
              value={studentData.parent_name}
              onChange={handleChange}
              className="border border-gray-300 px-3 py-2 rounded-md w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="parent_phone_number" className="mb-2 block">Parent Phone Number:</label>
            <input
              type="text"
              id="parent_phone_number"
              name="parent_phone_number"
              value={studentData.parent_phone_number}
              onChange={handleChange}
              className="border border-gray-300 px-3 py-2 rounded-md w-full"
              required
            />
          </div>
          <div className='flex justify-center'>
            <button type="submit" className="border-2 border-green-500 bg-none hover:bg-green-500 text-bold px-9 py-2 rounded-full focus:outline-none">
              Submit            
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStudent;
